// styling
import './css/base.css';

// // imager - cover images
// new Imager('.delayed-cover-image', {
//     availableWidths: [512,1024]
// });
//
// // imager - organisation logos
// new Imager('.delayed-logo', {
//     availableWidths: [256]
// });

// Slider
import './js/app.js';

// Slider
import './js/slider.js';

import './components/services/services.jsx';
import './components/news/news.jsx';
import './components/publications/publications.jsx';
import './components/board-executive/executives.jsx';
import './components/board-non-executive/non-executives.jsx';
import './components/related-content/related-content.jsx';
import './components/related-terms/related-terms.jsx';
import './components/meetings/meetings.jsx';
import './components/twitter-news/twitter-news.jsx';
import './components/practitioners/practitioners.jsx';



